import script from "./Chip.vue?vue&type=script&setup=true&lang=js"
export * from "./Chip.vue?vue&type=script&setup=true&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=3a8152e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8152e2"]])

export default __exports__